export enum OrderStage {
  // 订单状态 1审核中 2进行中 待验收 4待评价 5已完成
  ALL = 0,
  CHECK = 1,
  UNDERWAY = 2, // 进行中
  UNCONFIRMED = 3, // 待验收
  UNCOMMENT = 4, // 待评价
  COMPLETED = 5 // 已完成
}
